




















































import {
  Vue,
  Component,
} from "@/shared/vuepack";

import Button from "@/shared/components/ui/Button.vue";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUtilityStore } from "@/admin/store/utility";

@Component({
  components: {
    Button,
    Input,
    ErrorSummary
  }
})

export default class AdminUtilityMfaDisable extends Vue {
  $router: VueRouter;
  $validator: Validator;

  emailAddress = "";
  hubspotTicket = "";
  isLoaded = false;
  showConfirmResetModal = false;

  utilityStore = useUtilityStore();
  notifierStore = useNotifierStore();

  mounted () {
    this.initialize();
  }

  initialize () {
    this.emailAddress = "";
    this.hubspotTicket = "";
    this.isLoaded = true;
  }

  showError (message: string): void {
    this.notifierStore.setDanger(message);
  }

  handleError (err: any): void {
    this.showError(
      (err && err.errorMessage) ||
      "Error processing your request. Please try again later"
    );
  }

  cancelResetMfa () {
    this.showConfirmResetModal = false;
  }

  showConfirmResetMfa () {
    this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          return;
        }
        this.showConfirmResetModal = true;
      });
  }

  confirmResetMfa () {
    this.utilityStore.requestDisableMfa({
      emailAddress: this.emailAddress,
      hubspotTicketId: this.hubspotTicket
    }).then(result => {
      this.notifierStore.setSuccess(`MFA disable email sent to ${this.emailAddress}`);
    });
    this.showConfirmResetModal = false;
  }

  onClose () {
    this.showConfirmResetModal = false;
  }

}
